export const MUMBAI_LOCATIONS = [
  // Mumbai
  "Andheri East", "Andheri West", "Bandra East", "Bandra West", "Borivali East", "Borivali West",
  "Chembur", "Churchgate", "Colaba", "Dadar East", "Dadar West", "Dahisar East", "Dahisar West",
  "Fort", "Ghatkopar East", "Ghatkopar West", "Goregaon East", "Goregaon West", "Jogeshwari East",
  "Jogeshwari West", "Juhu", "Kandivali East", "Kandivali West", "Khar East", "Khar West",
  "Kurla East", "Kurla West", "Mahim", "Malad East", "Malad West", "Matunga", "Mulund East",
  "Mulund West", "Parel", "Powai", "Santa Cruz East", "Santa Cruz West", "Santacruz", "Sion",
  "Thane West", "Vile Parle East", "Vile Parle West", "Vikhroli East", "Vikhroli West",
  "Wadala", "Worli",
  
  // Navi Mumbai
  "Airoli", "Belapur", "Ghansoli", "Kamothe", "Kharghar", "Kopar Khairane", "Nerul",
  "Panvel", "Sanpada", "Seawoods", "Turbhe", "Vashi",
  
  // Thane
  "Thane East", "Thane West", "Bhiwandi", "Diva", "Dombivli East", "Dombivli West",
  "Kalwa", "Kalyan East", "Kalyan West", "Kasarvadavali", "Kolshet", "Manpada",
  "Mumbra", "Naupada", "Ulhasnagar", "Vartak Nagar", "Wagle Estate"
];

export const INDIAN_BANKS = [
  // Public Sector Banks
  "State Bank of India",
  "Punjab National Bank",
  "Bank of Baroda",
  "Canara Bank",
  "Union Bank of India",
  "Bank of India",
  "Indian Bank",
  "Central Bank of India",
  "Indian Overseas Bank",
  "UCO Bank",
  "Bank of Maharashtra",
  "Punjab & Sind Bank",

  // Private Sector Banks
  "HDFC Bank",
  "ICICI Bank",
  "Axis Bank",
  "Kotak Mahindra Bank",
  "Yes Bank",
  "IDFC First Bank",
  "IndusInd Bank",
  "Federal Bank",
  "RBL Bank",
  "South Indian Bank",
  "Karur Vysya Bank",
  "City Union Bank",
  "Jammu & Kashmir Bank",
  "DCB Bank",
  "Bandhan Bank",
  "IDBI Bank",
  "Tamilnad Mercantile Bank",
  "Dhanlaxmi Bank",
  "Nainital Bank",
  "CSB Bank (Catholic Syrian Bank)",
  "Karnataka Bank",
  "Lakshmi Vilas Bank",

  // Small Finance Banks
  "AU Small Finance Bank",
  "Equitas Small Finance Bank",
  "Ujjivan Small Finance Bank",
  "Jana Small Finance Bank",
  "Suryoday Small Finance Bank",
  "Fincare Small Finance Bank",
  "ESAF Small Finance Bank",
  "North East Small Finance Bank",
  "Capital Small Finance Bank",

  // Payments Banks
  "Airtel Payments Bank",
  "India Post Payments Bank",
  "Paytm Payments Bank",
  "Fino Payments Bank",
  "Jio Payments Bank",

  // Co-operative Banks – Maharashtra
  "NKGSB Co-operative Bank",
  "Thane Janata Sahakari Bank",
  "Saraswat Co-operative Bank",
  "Cosmos Co-operative Bank",
  "Shamrao Vithal Co-operative Bank (SVC Bank)",
  "Bassein Catholic Co-operative Bank",
  "Bharat Co-operative Bank",
  "Jankalyan Sahakari Bank",
  "Dombivli Nagari Sahakari Bank",
  "Kalyan Janata Sahakari Bank",
  "Thane Bharat Sahakari Bank",
  "Abhyudaya Co-operative Bank",
  "Apna Sahakari Bank",
  "Bombay Mercantile Co-operative Bank",
  "Citizen Credit Co-operative Bank",
  "GS Mahanagar Co-operative Bank",
  "Janakalyan Sahakari Bank (Pune)",
  "Kapol Co-operative Bank",
  "Mahanagar Co-operative Bank",
  "Nutan Nagarik Sahakari Bank",
  "Ratnakar Bank (now RBL Bank)",
  "Rupee Co-operative Bank",
  "Sangli Urban Co-operative Bank",
  "Thane District Central Co-operative Bank",
  "Vasai Vikas Sahakari Bank",
  "Vidya Sahakari Bank",

  // Co-operative Banks – Other States
  "Ahmedabad Mercantile Co-operative Bank",
  "Kalupur Commercial Co-operative Bank",
  "Mehsana Urban Co-operative Bank",
  "Rajkot Nagrik Sahakari Bank",
  "Surat People's Co-operative Bank",
  "Baroda Gujarat Gramin Bank",
  "Kerala Gramin Bank",
  "Andhra Pradesh Grameena Vikas Bank",
  "Telangana Grameena Bank",
  "Karnataka Vikas Grameena Bank",
  "Pragathi Krishna Gramin Bank",
  "Madhya Pradesh Gramin Bank",
  "Uttar Bihar Gramin Bank",
  "Sarva Haryana Gramin Bank",
  "Punjab Gramin Bank",

  // Regional Rural Banks
  "Baroda Rajasthan Kshetriya Gramin Bank",
  "Dena Gujarat Gramin Bank",
  "Maharashtra Gramin Bank",
  "Vidarbha Konkan Gramin Bank",

  // Others
  "Citibank",
  "HSBC",
  "Standard Chartered Bank",
  "Deutsche Bank",
  "DBS Bank India",
  "Barclays Bank",
  "Woori Bank",
  "Bank of America"
];

export const RELATIONS = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Spouse",
  "Friend",
  "Colleague",
  "Relative",
  "Neighbor",
  "Guardian"
];
